module.exports = __webpack_public_path__ + "img/contract-25.a4bbd6b6.svg";